import { createContext, useContext } from "react";
import { useStructure } from "@/hooks/useStructure";

// Stato condiviso tra le pagine Canali e Ruoli: mantiene le modifiche non salvate
// anche quando si passa da una tab all'altra (una sola istanza di useStructure).
const StructureContext = createContext(null);

export function StructureProvider({ children }) {
  const s = useStructure();
  return <StructureContext.Provider value={s}>{children}</StructureContext.Provider>;
}

export const useStructureCtx = () => useContext(StructureContext);
